
import XHeader from 'vux/src/components/x-header/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import vuescroll from 'vuescroll'
export default {
directives: {
TransferDom
},
name: 'dormroom',
props: [],
components: {
XHeader,
Search,
Panel,
'scroller': vuescroll,
Popup,
Checker,
CheckerItem,
XButton,
Flexbox,
FlexboxItem
},
data () {
return {
serach: {
results: [],
value: 'test',
autoFixed: false,
placeholder: '',
cancelText: ''
},
ops: {
scrollPanel: {
scrollingX: false
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
},
dormList: {
type: '5',
list: [{
src: '/src/assets/sass/images/bg/dorm01.png',

title: '15楼501',
desc: `<ul class="dorm-info">
<li>费用标准：¥1500555/学年</li>
<li>宿舍规格：标准四人间 </li>
</ul>`

}, {
src: '/src/assets/sass/images/bg/dorm01.png',
title: '15楼501',
desc: `<ul class="dorm-info">
<li>费用标准：¥1500/学年</li>
<li>宿舍规格：标准四人间 </li>
</ul>`,
url: {}
}, {
src: '/src/assets/sass/images/bg/dorm01.png',
title: '15楼501',
desc: `<ul class="dorm-info">
<li>费用标准：¥1500/学年</li>
<li>宿舍规格：标准四人间 </li>
</ul>`,
url: {}
}, {
src: '/src/assets/sass/images/bg/dorm01.png',
title: '15楼501',
desc: `<ul class="dorm-info">
<li>费用标准：¥1500/学年</li>
<li>宿舍规格：标准四人间 </li>
</ul>`,
url: {}
}, {
src: '/src/assets/sass/images/bg/dorm01.png',
title: '15楼501',
desc: `<ul class="dorm-info">
<li>费用标准：¥1500/学年</li>
<li>宿舍规格：标准四人间 </li>
</ul>`,
url: {}
}, {
src: '/src/assets/sass/images/bg/dorm01.png',
title: '15楼501',
desc: `<ul class="dorm-info">
<li>费用标准：¥1500/学年</li>
<li>宿舍规格：标准四人间 </li>
</ul>`,
url: {}
}]
},
isShowPanel: false,
value: '',
value1: ''
}
},
computed: {
title () {
return this.$route.params.title
}
},
created () {},
mounted () {},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
onFocus () {

},
onCancel () {
},
onSubmit () {
this.$refs.search.setBlur()
this.$vux.toast.show({
type: 'text',
position: 'top',
text: 'on submit'
})
},
onImgError (item, $event) {
console.log(item)
},
showPanel () {
this.isShowPanel = !this.isShowPanel
},
goDetail () {
this.$router.push({
name: 'dormroomDeatil'
})
},

saveFilter () {
this.isShowPanel = false
},

resetFilter () {
this.value = ''
this.value1 = ''
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/dormroom.vue